import React from "react";
import {Route} from "@/routing/Router";
import MenuOverviewHeading from "@widgets/menu/heading/MenuOverviewHeading";
import {useQuery} from "@tanstack/react-query";
import {api} from "@/data/api";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {PageHeading, Spinner} from "peggirkit";
import {Category} from "@/data/entities/menu";
import CategoriesList from "@widgets/menu/categories/nav/CategoriesList";
import {ADMIN_MENU_QUERY_KEY} from "@/data/entities/menuEditor";

type Props = {
    route: Route,
};

const MenuOverview = ({route}: Props) => {
    const {dashboardLocation} = useRestaurant();
    const {data: menu, isFetching} = useQuery({
        queryKey: [ADMIN_MENU_QUERY_KEY, dashboardLocation.id],
        queryFn: () => api.menuEditor.getMenu(dashboardLocation.id),
    });

    return (
        <>
            <MenuOverviewHeading
                route={route}
                isFetching={isFetching}
            />

            <div className={"mt-6 md:mt-12 w-full grid grid-cols-5 gap-6 md:gap-12 items-stretch"}>
                {
                    menu &&
                    <nav className={"col-span-5 md:col-span-2 xl:col-span-1 self-start md:sticky md:top-6"}>
                        <CategoriesList
                            menu={menu}
                            isFetching={isFetching}
                        />
                    </nav>
                }

                <ol className={"col-span-5 md:col-span-3 xl:col-span-4 w-full flex flex-col gap-8 md:gap-16"}>
                    {
                        menu === undefined
                            ? <Spinner size={"lg"}/>
                            : menu.categories.map((category: Category) =>
                                <li
                                    key={category.id}
                                    data-category-id={category.id}
                                    className={"flex flex-col h-[600px] w-full border-b"}
                                >
                                    <PageHeading
                                        titleSize={"sm"}
                                        title={category.name}
                                    />

                                    <p>
                                        Work in progress
                                    </p>
                                </li>
                            )
                    }
                </ol>
            </div>
        </>
    );
};

export default MenuOverview;